module.exports = __webpack_public_path__ + "img/logo.ea988845.svg";